import React from 'react';
import WebIcon from '../svg/web.svg';

const IconWeb = () => <img src={WebIcon} alt="Web Icon" width={64} height={64} />;

export default IconWeb;
